module.exports = __webpack_public_path__ + "img/roupeiros.a85dc4be.webp";